"use client";

import { c as _c } from "react/compiler-runtime";
import CustomSelect from "@/components/common/select/CustomSelect";
import { useResourceNav, type NavOption } from "./resource-nav";
import { useRef } from "react";

/** Sticky mobile section picker rendered inside the content column. */
export const ResourceSectionSelect = t0 => {
  const $ = _c(9);
  const {
    options
  } = t0;
  const {
    currentSection,
    onSelect,
    setOptions
  } = useResourceNav();
  const ref = useRef(null);
  const refObserver = useRef(null);
  let t1;
  if ($[0] !== setOptions) {
    t1 = node => {
      if (node) {
        ref.current = node;
        if (refObserver.current) {
          refObserver.current.disconnect();
        }
        refObserver.current = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              setOptions({
                offsetElement: node
              });
            }
          });
        });
        refObserver.current.observe(node);
      }
    };
    $[0] = setOptions;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleRef = t1;
  let t2;
  if ($[2] !== currentSection || $[3] !== onSelect || $[4] !== options) {
    t2 = <CustomSelect options={options} value={currentSection} onChange={onSelect} />;
    $[2] = currentSection;
    $[3] = onSelect;
    $[4] = options;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== handleRef || $[7] !== t2) {
    t3 = <div ref={handleRef} className="custom-select sticky top-[72px] z-[100] w-full bg-transparent bg-white !py-2 text-left lg:hidden">{t2}</div>;
    $[6] = handleRef;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default ResourceSectionSelect;